import { IPostEventAskPriceVisibleMessage } from '@webtrader/core/chart/events/askPriceVisible';

import {
  IPostEventChartDataMessage,
  IPostEventChartFeedMessage,
  IPostEventChartLoadMessage,
  IPostEventChartPatchMessage,
  IPostEventSetSymbolMessage,
  IPostEventSymbolFeedMessage,
  IReceiveEventChartFetchMoreMessage
} from './chart';
import { IReceiveEventOpenContextMenuMessage } from './contextMenu';
import {
  IPostEventOpenDrawingMessage,
  IPostEventRemoveDrawingMessage,
  IReceiveEventCompleteDrawingMessage,
  IReceiveEventDeleteDrawingMessage,
  IReceiveEventSelectDrawingToolMessage
} from './draw';
import {
  IPostEventIndicatorMessage,
  IPostEventTokenFormMessage,
  IPostEventUpdateIndicatorFormMessage,
  IReceiveEventIndicatorLoadMessage,
  IReceiveEventIndicatorMessage,
  IReceiveEventOpenIndicatorFormMessage
} from './indicators';
import { IPostEventIsNativeMessage } from './isNative';
import { IPostEventPeriodMessage } from './period';
import { IPostEventResetMessage, IPostEventScrollToLatestMessage } from './reset';
import { IPostEventSeriesMessage, IPostEventUpdateCandlestickColorMessage } from './series';
import { IReceiveEventEnqueueSnackbarMessage } from './snackbar';
import { IReceiveEventStatusMessage } from './status';
import { IPostEventSymbolMessage } from './symbol';
import { IPostEventThemeSchemeMessage } from './theme';
import {
  IPostEventBatchCancelTrackOrderMessage,
  IPostEventCancelTrackOrderMessage,
  IPostEventRevertEditTrackOrderPriceMessage,
  IPostEventTrackOrderMessage,
  IPostEventUpdateTrackOrderPriceMessage,
  IReceiveEventCloseOrderMessage,
  IReceiveEventEditTrackOrderPriceMessage
} from './track';
import { IPostEventTVSetThemeMessage } from './tv-change-theme';
import { IPostEventTVSetInitialConfigsMessage } from './tv-set-initial-configs';
import { IPostEventTVSetLanguageMessage } from './tv-set-language';
import { IPostEventTVSetPeriodMessage } from './tv-set-period';
import { IPostEventTVToggleIndicatorsMessage } from './tv-toggle-indicators';

export enum EEventMessageType {
  DELETE_DRAWING = 'DELETE_DRAWING',
  COMPLETE_DRAWING = 'COMPLETE_DRAWING',
  SELECT_DRAWING_TOOL = 'SELECT_DRAWING_TOOL',
  OPEN_DRAWING = 'OPEN_DRAWING',
  REMOVE_DRAWING = 'REMOVE_DRAWING',
  OPEN_CONTEXT_MENU = 'OPEN_CONTEXT_MENU',
  RESET = 'RESET',
  PERIOD = 'PERIOD',
  SERIES = 'SERIES',
  STATUS = 'STATUS',
  SYMBOLS = 'SYMBOLS',
  INDICATOR = 'INDICATOR',
  INDICATOR_LOAD = 'INDICATOR_LOAD',
  TRACK_ORDER = 'TRACK_ORDER',
  THEME_SCHEME = 'THEME_SCHEME',
  CANCEL_TRACKER_ORDER = 'CANCEL_TRACKER_ORDER',
  UPDATE_TRACK_ORDER_PRICES = 'UPDATE_TRACK_ORDER_PRICES',
  BATCH_CANCEL_TRACKER_ORDER = 'BATCH_CANCEL_TRACKER_ORDER',
  ASK_PRICE_VISIBLE = 'ASK_PRICE_VISIBLE',
  EDIT_TRACK_ORDER_PRICE = 'EDIT_TRACK_ORDER_PRICE',
  REVERT_EDIT_TRACK_ORDER_PRICE = 'REVERT_EDIT_TRACK_ORDER_PRICE',
  SCROLL_TO_LATEST = 'SCROLL_TO_LATEST',
  OPEN_INDICATOR_CONFIG = 'OPEN_INDICATOR_CONFIG',
  UPDATE_INDICATOR_CONFIG = 'UPDATE_INDICATOR_CONFIG',
  TOKEN = 'TOKEN',
  CLOSE_ORDER = 'CLOSE_ORDER',
  SYMBOL_CHART_DATA = 'SYMBOL_CHART_DATA',
  SYMBOL_FEED = 'SYMBOL_FEED',
  CHART_FEED = 'CHART_FEED',
  CHART_PATCH = 'CHART_PATCH',
  CHART_LOAD = 'CHART_LOAD',
  SET_SYMBOL = 'SET_SYMBOL',
  CHART_FETCH_MORE = 'CHART_FETCH_MORE',
  UPDATE_CANDLESTICK_COLOR = 'UPDATE_CANDLESTICK_COLOR',
  IS_NATIVE = 'IS_NATIVE',
  ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR',

  // Trading view specific events
  TV_SET_PERIOD = 'TV_SET_PERIOD',
  TV_TOGGLE_INDICATORS = 'TV_TOGGLE_INDICATORS',
  TV_CHANGE_THEME = 'TV_CHANGE_THEME',
  TV_SET_INITIAL_CONFIGS = 'TV_SET_INITIAL_CONFIGS',
  TV_SET_LANGUAGE = 'TV_SET_LANGUAGE'
}

export type IPostEventMessage =
  | IPostEventOpenDrawingMessage
  | IPostEventRemoveDrawingMessage
  | IPostEventResetMessage
  | IPostEventPeriodMessage
  | IPostEventSeriesMessage
  | IPostEventSymbolMessage
  | IPostEventIndicatorMessage
  | IPostEventTrackOrderMessage
  | IPostEventThemeSchemeMessage
  | IPostEventBatchCancelTrackOrderMessage
  | IPostEventCancelTrackOrderMessage
  | IPostEventUpdateTrackOrderPriceMessage
  | IPostEventAskPriceVisibleMessage
  | IPostEventRevertEditTrackOrderPriceMessage
  | IPostEventScrollToLatestMessage
  | IPostEventUpdateIndicatorFormMessage
  | IPostEventTokenFormMessage
  | IPostEventChartDataMessage
  | IPostEventSymbolFeedMessage
  | IPostEventChartFeedMessage
  | IPostEventChartPatchMessage
  | IPostEventChartLoadMessage
  | IPostEventSetSymbolMessage
  | IPostEventUpdateCandlestickColorMessage
  | IPostEventIsNativeMessage
  | IPostEventTVSetPeriodMessage
  | IPostEventTVSetThemeMessage
  | IPostEventTVSetInitialConfigsMessage
  | IPostEventTVToggleIndicatorsMessage
  | IPostEventTVSetLanguageMessage;

export type IReceiveEventMessage =
  | IReceiveEventIndicatorMessage
  | IReceiveEventIndicatorLoadMessage
  | IReceiveEventStatusMessage
  | IReceiveEventOpenContextMenuMessage
  | IReceiveEventOpenIndicatorFormMessage
  | IReceiveEventSelectDrawingToolMessage
  | IReceiveEventCompleteDrawingMessage
  | IReceiveEventDeleteDrawingMessage
  | IReceiveEventEditTrackOrderPriceMessage
  | IReceiveEventCloseOrderMessage
  | IReceiveEventChartFetchMoreMessage
  | IReceiveEventEnqueueSnackbarMessage;
